<template lang="html">
    <div>
        <div class="alert alert-danger" v-if="formErrors">
            <p><strong>Whoops!</strong> Something went wrong!</p>
            <br>
            <ul>
                <li v-for="error in form.errors">
                    {{ error[0] }}
                </li>
            </ul>
        </div>
        <form class="form-horizontal" role="form" @submit.prevent="addBudgetGroup">
            <!-- Name -->
            <div class="form-group">
                <label class="col-md-4 control-label">Name</label>

                <div class="col-md-6">
                    <input type="text" class="form-control" name="name" v-model="form.name">
                </div>
            </div>
            <!-- Budget -->
            <div class="form-group">
                <label class="col-md-4 control-label">Budget</label>

                <div class="col-md-6">
                    <input type="text" class="form-control" name="budget" v-model="form.budget">
                </div>
            </div>

            <div class="form-group">
                <label class="col-md-4 control-label">Budget Type</label>

                <div class="col-md-6">
                    <select class="form-control" name="budget_type" v-model="form.type">
                        <option value="monthly">Monthly</option>
                        <option value="custom">Custom</option>
                    </select>
                </div>
            </div>

            <!-- Date Range -->
            <div class="form-group daterange"  v-show="form.name !== 'Monthly' && form.type !== 'monthly'">
                <label class="col-md-4 control-label">Range</label>

                <div class="col-md-3">
                    <datepicker v-model="form.start" format="yyyy-MM-dd" icons-font="fa"></datepicker>
                </div>

                <div class="col-md-3">
                    <datepicker v-model="form.end" format="yyyy-MM-dd" icons-font="fa"></datepicker>
                </div>
            </div>

            <div class="form-group">
                <label class="col-md-4 control-label">Exclude Weekends</label>

                <div class="col-md-6">
                    <select class="form-control" name="exclude_weekends" v-model="form.exclude_weekends">
                        <option value="0">No</option>
                        <option value="1">Yes</option>
                    </select>
                </div>
            </div>

            <p class="form-text text-muted col-md-6 col-md-offset-4">
                <strong>Note:</strong> Be sure to assign campaigns from the applicable Ad Accounts.
            </p>

            <!-- Add Button -->
            <div class="form-group">
                <div class="col-md-offset-4 col-md-6">
                    <button type="submit" class="btn btn-primary" :class="{'btn-loading': loading}" :disabled="loading">
                        Add Budget Group
                    </button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { datepicker } from 'vue-strap';

export default {
    data() {
        return {
            form: {
                name: '',
                budget: '',
                client_name: '',
                exclude_weekends: '0',
                errors: '',
                type: 'monthly',
                start: '',
                end: ''
            },
            loading: false
        }
    },

    components: {
        datepicker
    },

    computed: {
        ...mapGetters('client', {
            'client': 'activeClient',
            'isAdmin': 'isAdmin',
        }),

        daterange() {
            return `${this.form.start} - ${this.form.end}`;
        },

        formErrors() {
            return Object.keys(this.form.errors).length > 0;
        }
    },

    mounted() {
        this.form.start = `${moment().date(1).format('YYYY-MM-DD')}`;
        this.form.end =  `${moment().add(1,'month').date(0).format('YYYY-MM-DD')}`;

        const self = this;
    },

    methods: {
        addBudgetGroup() {
            this.loading = true;
            setTimeout(() => this.loading = false, 3000);
            this.form.client_name = this.client.name;
            let budgetGroup = this.form;
            this.$store.dispatch('client/addBudgetGroup', {
                    budgetGroup: budgetGroup,
                }).then(response => {
                    Bus.$emit('show-success-alert', response.message);
                    Bus.$emit('budget-group-added');
                    this.reset();
                })
                .catch(response => {
                    if (response.status !== 422) {
                        Bus.$emit('show-error-alert', response.data.message);
                    } else {
                        this.form.errors = response.data.errors;
                    }
                    this.loading = false;
                });
        },

        reset() {
            Object.assign(this.$data, this.$options.data());
        }
    },
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/clients/NewBudgetGroupForm.vue